<template>
  <gmap-map class="map" :center="mapCenter" :options="mapConfig">
    <gmap-marker
      :key="index"
      v-if="appIsActive"
      v-for="(marker, index) in getLocations"
      :position="marker.coords"
      :clickable="true"
      :draggable="false"
      :animation="2"
      :icon="{
        url: getSVGmarker(getActiveLocation && marker.id === getActiveLocation.id, index + 1),
        scaledSize: { width: 52, height: 66 }
      }"
      @click="setActiveLocation(marker)"
    ></gmap-marker>
  </gmap-map>
</template>

<script>
import MapStyles from '../map-styles'
import MapConfig from '../map-config'
import AppConfig from '../app-config'

import Vue from 'vue'
import * as VuegleMaps from 'vue2-google-maps'

import { mapMutations, mapGetters } from 'vuex'

Vue.use(VuegleMaps, {
    load: {
      key: 'AIzaSyAMwFFFeK2HynZHDrKweUfuMIAXesavGjs',
      libraries: 'places'
    }
})

export default {
  name: 'vuegle-maps',
  props: {
    markers: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(['getLocations', 'getActiveLocation', 'appIsActive']),
    mapCenter () {
      return this.appIsActive ? this.mapConfig.centerPoint : this.altMapCenter
    }
  },
  methods: {
    ...mapMutations(['setActiveLocation']),
    getSVGmarker (isActiveState, index) {
      const stateColor = AppConfig.themeColors[isActiveState ? 'highlight' : 'primary']
      const mimeType = 'data:image/svg+xml'
      const svg = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="66" viewBox="0 0 52 66" xml:space="preserve"><style>.text { fill: white; font: 30px arial; font-weight: bold; }</style>
        <path fill="#1E4B60" d="M26,0C11.6,0,0,11.6,0,26c0,12.9,8.7,26.2,26,40c17.3-13.8,26-27.1,26-40C52,11.6,40.4,0,26,0z M26,51 C12.2,51,1,39.8,1,26S12.2,1,26,1s25,11.2,25,25S39.8,51,26,51z"/>
        <g>
          <circle fill="${stateColor}" cx="26" cy="26" r="25"/>
          <path fill="#FFFFFF" d="M26,2c13.3,0,24,10.7,24,24S39.3,50,26,50S2,39.3,2,26S12.7,2,26,2 M26,1C12.2,1,1,12.2,1,26s11.2,25,25,25 s25-11.2,25-25S39.8,1,26,1L26,1z"/>
        </g>
        <text class="text" text-anchor="middle" transform="matrix(1 0 0 1 26 37)">${index}</text>
      </svg>`

      return `${mimeType},${encodeURIComponent(svg)}`
    }
  },
  data () {
    return {
      mapConfig: { styles: MapStyles, ...MapConfig },
      altMapCenter: { lat: 53.680299, lng: -17.514638 }
    }
  }
}

</script>

<style lang="scss" scoped>

@import '../assets/variables';

  .map {
    display:none;
  }

  @media #{$breakpoint-md} {
    .map {
      width: 100vw;
      height: 100vh;
      position: absolute;
      display:block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VuegleMaps.vue